import { render, staticRenderFns } from "./LegalConsultant.vue?vue&type=template&id=29a0af5c&scoped=true"
import script from "./LegalConsultant.vue?vue&type=script&lang=js"
export * from "./LegalConsultant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a0af5c",
  null
  
)

export default component.exports